module.exports = __webpack_public_path__ + "media/images/product/p_l-63b0922bec4d0e56876146adb20050f6.png";